import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';

const urls = [
  /\/bulk\/catalog/,
  /\/custom-swag-packs\/catalog/,
  /\/products\/order/,
  /\/send-swag\//,
  /\/orders-requested\/[0-9]+\/?$/,
  /\/orders-requested\/[0-9]+\/select-products/,
  /\/orders-requested\/[0-9]+\/select-recipients/,
  /\/orders-requested\/[0-9]+\/create-shipment/,
  /\/orders-requested\/[0-9]+\/order-overview/,
  /\/reorder\/select-quantities/
];

const useIntercomOnLeft = () => {
  const location = useLocation();
  const { update } = useIntercom();
  const moveIntercomLeft = urls.some(url => url.test(location.pathname));

  React.useEffect(() => {
    if (moveIntercomLeft) {
      update({
        alignment: 'left',
        horizontalPadding: 20,
        verticalPadding: 20
      });
    }

    return () => {
      update({
        alignment: 'right',
        horizontalPadding: 20,
        verticalPadding: 20
      });
    };
  }, [moveIntercomLeft, update]);
};

export default useIntercomOnLeft;
